import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import './style.scss';

export const BingoNotificationDot = observer((props: { type?: 'small' | 'normal' }) => {
  const { bingoStore } = useStores();
  const { shouldShowFreeDaubDot, hasPendingFeaturedPrize } = bingoStore;

  if (!shouldShowFreeDaubDot && !hasPendingFeaturedPrize) return null;

  return (
    <div className={`notification-dot ${props.type || ''}`}>
      <div className="dot"></div>
    </div>
  );
});
